<template>
    <div class="col-12 col-sm-11 mx-auto mt-5">
        <h2 class="text-primary font-weight-bold text-center">Si quieres más información</h2>
        <p class="text-center col col-lg-9 col-xl-6 mx-sm-auto mt-3">Inscríbete a nuestro newsletter y mantente actualizado con 
            todo lo que necesitas conocer referente a propiedades con Subsidio.</p>
        <form id="form-newsletter" class="row" @submit.prevent="sendNewsletterForm" method="POST">
            <input type="hidden" name="_token" :value="csrf">
            <div class="input-group col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto">
                <input type="text"
                    name="email"
                    v-model.trim="$v.form.email.$model"
                    placeholder="Ingresa tu email" 
                    aria-label="Ingresa tu email" 
                    aria-describedby="button-addon2"
                    class="form-control input-newsletter">
                <div class="input-group-append">
                    <button :disabled="formLoading" class="btn btn-primary boton-newsletter px-4" 
                        type="submit" id="button-addon2">
                        <i class="fa fa-arrow-right text-white"></i>
                    </button>
                </div>
            </div>
            <div class="col-12 pt-0">
                <div class="pt-0 col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto error-data" v-if="$v.form.email.$dirty">
                    <span v-if="!$v.form.email.required">Debe ingresar el email</span>
                    <span v-if="!$v.form.email.email">Email inválido</span>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { required, email } from "vuelidate/lib/validators";

    export default {
        name: "NewsletterHome",
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                formLoading: false,
                form: {
                    email: ""
                }
            }
        },
        methods: {
            sendNewsletterForm() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    this.formLoading = true;
                    const rutaForm = window.BASE_URL + '/newsletter-form'
                    $('#form-newsletter').attr('action', rutaForm).submit();
                }
            },
        },
        validations: {
            form: {
                email: {
                    email,
                    required
                },
            },
        },
    }
</script>

<style>
</style>